export default "__VITE_ASSET__CYN_Qr_7__"